import { MessageCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'motion/react';

interface ChatLauncherProps {
  onClick?: () => void;
  isOpen?: boolean;
}

export function ChatLauncher({ onClick, isOpen }: ChatLauncherProps) {
  return (
    <AnimatePresence>
      {!isOpen && (
        <motion.button
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.2 }}
          onClick={onClick}
          className="fixed bottom-6 right-6 z-40 group bg-[#0B3D91] text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 p-4 hover:scale-105"
        >
          <MessageCircle className="w-7 h-7" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}